import React__default, { useLayoutEffect } from 'react';
import { Box } from '../Box/Box.web.js';
import { yearItem, yearContainer } from './styles.js';
import { getYearItems } from './utils.js';
import { ThemeProvider } from 'styled-components';
import { TrapFocus } from '../utils/components/TrapFocus/TrapFocus.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { useHighlightActive } from '../utils/hooks/useHighlightActive.web.js';
import { spacing } from '../constants/spacing.js';

var DateBrowserYearSelector = function DateBrowserYearSelector(props) {
  var color = props.color,
    onSelect = props.onSelect,
    onClose = props.onClose,
    selected = props.selected,
    minDate = props.minDate,
    maxDate = props.maxDate;
  var listContainerRef = /*#__PURE__*/React__default.createRef();
  var theme = useTheme();
  var yearItems = React__default.useMemo(function () {
    return getYearItems(minDate, maxDate).map(function (value) {
      return {
        value: value,
        name: value.toString()
      };
    }).reverse();
  }, [minDate, maxDate]);
  var handleSelect = React__default.useCallback(function (value) {
    var date = new Date();
    date.setFullYear(value);
    onSelect(date);
    onClose();
  }, [onSelect, onClose]);
  var selectedYear = selected.getFullYear();
  var _useHighlightActive = useHighlightActive(true, yearItems, selectedYear, handleSelect, onClose, {
      activateFirstItem: true,
      disableMouseMoveHandling: true
    }),
    active = _useHighlightActive.active,
    activeRef = _useHighlightActive.activeRef;
  useLayoutEffect(function () {
    var listContainer = listContainerRef.current;
    var selectedItem = activeRef.current;
    // istanbul ignore next -- not really sensible to test
    if (listContainer === null || selectedItem === null) {
      return;
    }
    listContainer.scrollTop = selectedItem.offsetTop - listContainer.getBoundingClientRect().height / 2 + selectedItem.getBoundingClientRect().height / 2;
  }, [listContainerRef, activeRef]);
  var yearItemButtons = yearItems.map(function (item, idx) {
    var isSelected = active === item.value;
    return /*#__PURE__*/React__default.createElement(yearItem, {
      key: item.value.valueOf(),
      "aria-posinset": idx + 1,
      "aria-setsize": yearItems.length,
      ref: isSelected ? activeRef : undefined,
      role: "option",
      selected: isSelected,
      "aria-label": item.name,
      tabIndex: isSelected ? 0 : -1,
      color: color,
      onClick: function onClick() {
        return handleSelect(item.value);
      }
    }, item.name);
  });
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(yearContainer, {
    ref: listContainerRef,
    $displayedItems: 5
  }, /*#__PURE__*/React__default.createElement(TrapFocus, {
    enabled: true,
    disableFocusRestore: true,
    refProp: "boxRef"
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    tag: "ul",
    ph: spacing.xxxs,
    flexDirection: "column",
    role: "listbox",
    whiteSpace: "nowrap",
    mv: 0
  }, yearItemButtons))));
};

export { DateBrowserYearSelector };
